// Text carried over from the previous site. Confirm it matches public/cv/CV.pdf before launch.
// Newest first. `place`, `type` and `focus` are optional and only shown when set.
export const experience = [
  {
    role: 'SOC Engineer',
    company: 'EY Indonesia',
    period: '09/2025 – Present',
    place: 'Jakarta, Indonesia',
    type: 'Full-time',
    focus: ['Splunk', 'Technical operations', 'Detection use cases', 'Incident response retainer'],
    points: [
      'Run day-to-day technical operations for the SOC’s Splunk platform, troubleshooting and resolving technical issues.',
      'Create detection use cases.',
      'Support security incident response, including incident response retainer (IRR) engagements.',
    ],
  },
  {
    role: 'Client Engineering',
    company: 'IBM Indonesia',
    period: '06/2024 – 02/2025',
    place: 'Jakarta, Indonesia',
    type: 'Internship',
    points: [
      'Developed and implemented frontend interfaces, ensuring seamless user experiences by aligning UI components with design specifications and enterprise standards.',
      'Designed and implemented an AI-powered document processing pipeline using LLM, incorporating context-aware chunking, OCR integration, and model fine-tuning to generate precise and contextually accurate outputs.',
      'Developed and implemented a backend architecture, ensuring efficient API handling, data processing, and seamless integration with frontend and database systems.',
    ],
  },
  {
    role: 'Application & Internal Services',
    company: 'IBM JTI',
    period: '02/2024 – 06/2024',
    place: 'Jakarta, Indonesia',
    type: 'Internship',
    points: [
      'Monitored and analyzed security events using SIEM tools, identifying and mitigating potential threats to enhance the organization’s security posture.',
      'Investigated and responded to security incidents, coordinating mitigation efforts to reduce potential attack surfaces and prevent recurring threats.',
      'Performed internal penetration testing on IBM JTI’s internal service applications, identifying vulnerabilities and providing remediation recommendations to strengthen system defenses.',
      'Developed comprehensive security reports, detailing threat analysis, incident response actions, and penetration testing findings to improve internal security strategies.',
      'Contributed to security audits and compliance checks, ensuring that internal applications adhere to best security practices and industry standards.',
    ],
  },
];
